import React, { Component } from 'react';
import { connect } from "react-redux";
// import ReactDOM from 'react-dom';
import 'react-bootstrap';

// import $ from "jquery/dist/jquery.js";
import mediaApi from "../../api/mediaApi";
import ScrollToTop from '../home/ScrollToTop/ScrollToTop';
import store from '../../store/configureStore';
import Pagination from '../../components/pagination/Pagination';
import MediaBlock from './MediaBlock';
import { lang } from '../../config/lang';
import { changeActiveItemAction } from '../../actions/navAction';
import { changeTopBannerAction } from '../../actions/topBannerAction';
import { addNotification } from "../../actions/notificationAction";
import { Businesses } from '../../config/Helper';
import NoData from '../../components/NoData';
import $ from "jquery/dist/jquery.js";
import { withRouter } from 'react-router-dom';
// import { lang } from '../../config/lang';



class PortfolioList extends Component {



    constructor(props) {
        super(props);

        this.state = {
        };
        this.arrCategory = ['all', 'image', 'video'];
        this.perPage = 8;
        this.bs = "all";
        this.category = "all";
        this.search_key = '';
        this.paginate = {
            currentPage: 1,
            lastPage: 1,
            visible: 6
        }

        this.getMedias = this.getMedias.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onPerPageChange = this.onPerPageChange.bind(this);
        this.checkSearchKey = this.checkSearchKey.bind(this);
    }

    componentWillMount() {
        this.getMedias();
        store.dispatch(changeActiveItemAction(Businesses.indexOf('media')));
        store.dispatch(changeTopBannerAction({
            page: 'media',
            showSearch: true,
            isHome: false,
            arrCategory: ['all', 'image', 'video'],
            onSearch: this.onSearch,
            curPage: this.paginate.currentPage
        }));

    }

    componentDidMount() {

        window.onSetClass('light');
        window.onClose();
        window.scrollTop('#top_banner');
        const search = this.props.history.location.search.split('?');
        let queryParams;

        if (search.length > 1) {
            const query = search[1].split('=');

            if (query.length) {
                queryParams = { [query[0]]: parseInt(query[1]) };
                // this.setState({ curPage: queryParams.page });
                this.paginate.currentPage = queryParams.page

            }
        }

        this.currentPage = $('#perpage_selector').val()
        this.getMedias(false, queryParams && queryParams.page ? queryParams.page : this.paginate.currentPage);
    }

    componentDidUpdate() {
        window.image();
        window.playVideo();
    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(newProps) {
        if (newProps.language.lang_key !== this.props.language.lang_key) {
            const search = this.props.history.location.search.split('?');
            let queryParams;

            if (search.length > 1) {
                const query = search[1].split('=');

                if (query.length) {
                    queryParams = { [query[0]]: parseInt(query[1]) };
                    // this.setState({ curPage: queryParams.page });
                    this.paginate.currentPage = queryParams.page

                }
            }
            this.currentPage = $('#perpage_selector').val()
            this.getMedias(false, queryParams && queryParams.page ? queryParams.page : this.paginate.currentPage);
        }
    }

    // isArray(what) {
    //     return Object.prototype.toString.call(what) === '[object Array]';
    // }

    getMedias(willGoList, page) {
        this.setState({
            loading: true,
        })
        if (this.currentPage) {
            mediaApi.paginate(this.paginate.currentPage, this.bs, this.category, this.search_key, this.currentPage).then((json) => {
                if (json.status === 200) {
                    // this.paginate.currentPage = json.data.currentPage;
                    this.paginate.lastPage = json.data.lastPage;
                    const medias = Array.isArray(json.data.data) ? json.data.data : [];

                    this.setState({
                        loading: false,
                        arrMedia: medias,
                        currentPage: json.data.currentPage,
                        lastPage:json.data.lastPage,
                        total: json.data.total
                    });

                    window.contentWayPoint();
                    // willGoList && window.scrollTop('#mediaListSection');

                } else {
                    store.dispatch(addNotification('Server error', 'error'));
                }
            })
        }
    }
    checkSearchKey(str) {
        var patt = new RegExp(/[@#!$%^&*~{}|><"/+_()]/g);
        // if (str === '') return false;
        if (patt.test(str)) {
            return false;
        } else {
            return true;
        }
    };
    onSearch(key, bs, category) {
        if (!this.checkSearchKey(key)) return;
        if (this.search_key === key && this.bs === bs && this.category === category) {
            return;
        }
        this.search_key = key;
        this.bs = bs;
        this.category = category;
        this.paginate.currentPage = 1;
        this.getMedias(true);
    }
    onChangePage(page) {
        this.paginate.currentPage = page;
        this.props.history.push("/portfolio" + "?" + "page=" + page)
        this.getMedias(true, page);
    }
    onPerPageChange() {
        this.currentPage = $('#perpage_selector').val()
        this.getMedias(true);
    }
    render() {
        return (
            <div>
                <div className='select-perpage'>
                    <select className="form-control rounded" name="" id="perpage_selector" onChange={this.onPerPageChange}>
                        <option value={8} key={1}>8</option>
                        <option value={12} key={2}>12</option>
                        <option value={16} key={3}>16</option>
                    </select>
                </div>
                <section className='select-selection'>
                    <div className="container">
                        <div className="row justify-content-center pb-5">
                            <div className="block-27">
                                <div className="row flex-column align-items-center">
                                    <div className="mt-1 mb-2 align-items-center">
                                        {`${lang('total')}` + this.state.total}
                                    </div>
                                </div>
                                {
                                    this.state.arrMedia &&
                                    this.state.arrMedia.length > 0 &&
                                    <Pagination
                                        total={this.state.lastPage}
                                        curPage={this.state.currentPage}
                                        visible={this.paginate.visible}
                                        onChangePage={this.onChangePage}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <section className="ftco-section" id="mediaListSection">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 pr-lg-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        {
                                            this.state.arrMedia &&
                                            this.state.arrMedia.map((media, key) => (
                                                <div className="post-box col-12 col-sm-6 col-md-4 col-lg-3 ftco-animate" data-animate-effect="fadeIn" key={key}>
                                                    <MediaBlock
                                                        business={media.business}
                                                        id={media.business_id}
                                                        title={media.title}
                                                        image={media.name}
                                                        media_type={media.format}
                                                        currentPage={this.paginate.currentPage}
                                                        keyword={this.search_key}
                                                    />
                                                </div>

                                            ))
                                        }

                                        {
                                            this.state.arrMedia && this.state.arrMedia.length === 0 && !this.state.loading &&
                                            <NoData />
                                        }
                                    </div>
                                </div>

                                <section className='select-selection'>
                                    <div className="container">
                                        <div className="row justify-content-center pb-5">
                                            <div className="block-27">
                                                {
                                                    this.state.arrMedia &&
                                                    this.state.arrMedia.length > 0 &&
                                                    <Pagination
                                                        total={this.state.lastPage}
                                                        curPage={this.state.currentPage}
                                                        visible={this.paginate.visible}
                                                        onChangePage={this.onChangePage}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <ScrollToTop />
                                {/* <nav className="ftco-navbar-light site-navbar-target">
                                    <div id="nav_box" ref="navbox" className="collapse navbar-collapse header-floating" style={{ display: 'none' }}>
                                        <ul className="navbar-nav nav sidebar-nav  ml-auto" style={{ position: 'fixed', right: '10px', bottom: '100px' }}>
                                            <li className="nav-item shortbar-item">
                                                <a href="#" className="nav-link sidebar-link" title=""><i className="icon icon-arrow-up"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </nav> */}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default withRouter(connect(mapStateToProps)(PortfolioList));